module.exports = __webpack_public_path__ + "static/media/smart.b7d3d67c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_page_solutions/chifco_iot/smart.svg
// module id = 660
// module chunks = 0